import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { StickyBarContainer } from '../../../containers/StickyBarContainer';
import { ComparePopupAlpha } from '../compare-popup/ComparePopupAlpha';
import { PDP_TABS_PORTAL_NAME } from '../product-detail-tab/ProductDetailTabPopover';
import { useState } from 'react';
export const ProductDetailOverlays = () => {
    const [isHiddenStickyBar, setHiddenStickyBar] = useState(true);
    const { feature_toggles: { show_sticky_bar_pdp }, pageInfo: { isGiftCardPage }, } = useAemConfig();
    return (_jsxs(_Fragment, { children: [show_sticky_bar_pdp && !isGiftCardPage && (_jsx(StickyBarContainer, { isHidden: isHiddenStickyBar, setHidden: setHiddenStickyBar })), _jsx(ComparePopupAlpha, { isStickyBar: !isHiddenStickyBar }), _jsx("div", { id: PDP_TABS_PORTAL_NAME })] }));
};
